import { Component, OnInit } from '@angular/core';
// import {MatTreeModule} from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';


import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

/**
 * Account data with nested structure.
 * Each node has a name and an optional list of children.
 */
interface AccountNode {
  acct_number: string;
  sub_acct_name: string;
  sub_acct_name_en: string;
  parent_acct: string;
  children?: AccountNode[];
}

/** Flat node with expandable and level information */
interface FlatNode {
  expandable: boolean;
  acct_number: string;
  sub_acct_name: string;
  sub_acct_name_en: string;
  level: number;
}


/**
 * @title Tree with flat nodes
 */
@Component({
  selector: 'app-chart-accts',
  templateUrl: './chart-accts.component.html',
  styleUrls: ['./chart-accts.component.css']
})
export class ChartAcctsComponent implements OnInit {

  public menu_item_id = '9';
  public add_auth;
  public edit_auth;
  public del_auth;

  private _transformer = (node: AccountNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      acct_number: node.acct_number,
      sub_acct_name: node.sub_acct_name,
      sub_acct_name_en: node.sub_acct_name_en,
      level: level,
    };
  }

  tree_data: AccountNode[] = [];
  treeControl = new FlatTreeControl<FlatNode>(
      node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
      this._transformer, node => node.level, node => node.expandable, node => node.children);

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);


  constructor(private utils: Utils, public applicationConstants: ApplicationConstants, private queryList: QueryList,
    public translate: TranslateService) {
      // this.getMessages(translate);
  }

  // getMessages(translate) {

  //   translate.setDefaultLang(this.applicationConstants.user_lang);
  //   translate.use(this.applicationConstants.user_lang);

  //   translate.get('Success_Msg').subscribe((res: string) => {
  //     this.Success_Msg = res;
  //   });

  //   translate.get('Error_Msg').subscribe((res: string) => {
  //     this.Error_Msg = res;
  //   });

  //   translate.get('Del_Msg').subscribe((res: string) => {
  //     this.Del_Msg = res;
  //   });

  //   translate.get('Del_Acct_Msg').subscribe((res: string) => {
  //     this.Del_Acct_Msg = res;
  //   });

  //   translate.get('Add').subscribe((res: string) => {
  //     this.Add = res;
  //   });

  // }

  hasChild = (_: number, node: FlatNode) => node.expandable;

  ngOnInit() {

    ////////////////////////////// Get acct tree /////////////////////////// 

    let obj = { cmd: 'getAccountList' };
    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        console.log(data.data['list']); 

        let result = [];
        data.data['list'].forEach(element => {
          result.push({ acct_number: element.acct_number, sub_acct_name: element.sub_acct_name, 
            sub_acct_name_en: element.sub_acct_name_en, parent_acct: element.parent_acct })
        });
        
        // build tree
        let root = [];
        let obj = {};

        result.forEach(element => {
          obj[element.acct_number] = element;
          element.children = [];
        });

        result.forEach(element => {
          if (element.parent_acct in obj) 
            obj[element.parent_acct].children.push(element);
          else
            root.push(obj[element.acct_number]);
        });
        this.dataSource.data = root;
        console.log(root);
      });

  }

}
